import { useMemo } from 'react';

import { ColumnType, TableColumns } from '../constants';

export function useTableColumns(metricsKeys) {
  return useMemo(() => {
    if (!metricsKeys) return null;

    const wIndex = Math.min(metricsKeys.length, 3);

    return TableColumns.reduce((acc, column) => {
      if (column.type === ColumnType.metrics) {
        return [
          ...acc,
          ...metricsKeys.map(key => ({
            ...column,
            key,
            width: column.width[wIndex],
          })),
        ];
      }
      return [...acc, { ...column, width: column.width[wIndex] }];
    }, []);
  }, [metricsKeys]);
}
